import { Link, navigate } from "gatsby";
import React, { ReactNode, useState } from "react";
import Dropdown from "../Dropdown";
import { Bars3Icon, ClockIcon, EnvelopeIcon, MapPinIcon, PhoneIcon, XMarkIcon } from "@heroicons/react/24/solid";
import anchor from "../../images/boat.png"
import MobileNavbar from "./MobileNavbar";
import NavElement from "../../models/NavItem";
import { useTranslation } from "../../contexts/TranslationContext";

// Translation object for the navbar
const LINKS = [
    { name: "home", path: "/" },
    { name: "aboutUs", path: "/about/" },
    { name: "services", path: "/services/" },
    { name: "gallery", path: "/gallery/" },
    { name: "contact", path: "/contact/" },
    { name: "certificates", path: "/certificates/" },
];

const NavItem = ({ icon, title, desc }: { icon: ReactNode, title: string | ReactNode, desc: string }) => {
    return <div className="flex gap-3 cap-first"><div className="bg-primary rounded-full p-3 w-fit h-fit">{icon}</div> <div className="flex flex-col"> <div className="font-bold">{title}</div><div className="text-gray-500 cap-first">{desc}</div></div></div>
}

function Navbar({ location }: { location: any }) {

    const { t, lang } = useTranslation();

    const [open, setOpen] = useState(false);

    function toggleMenu() {
        if (!open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        setOpen(!open);
    }

    const renderNavItems = () => {
        return LINKS.map((item: NavElement, index) => {
            if (item.dropdown) {
                return (
                    <li key={index}>
                        <Dropdown
                            title={item.name}
                            items={item.dropdown}
                            path={item.dropdown[0].path}
                            active={location?.pathname.indexOf(item.dropdown[0].path) === 0}
                        />
                    </li>
                );
            } else {
                return (
                    <li key={index} className={`py-2 font-bold transition-all duration-500 underline-offset-8 decoration-2 ${location?.pathname === `/${lang}${item.path}` ? "underline" : "hover:underline"}`}>
                        <Link to={`/${lang}${item.path}`}>{t(item.name)}</Link>
                    </li>
                );
            }
        });
    };

    const switchLanguage = (newLang: string) => {
        const currentPath = location.pathname;
        const newPath = currentPath.replace(/^\/(en|fr)/, `/${newLang}`);
        navigate(newPath);
    };


    return (
        <>
            <header className="w-full relative z-20 font-[Oswald,sans-serif] border-b-8 border-primary sm:border-none">
                <nav className="bg-secondary h-[115px] flex items-center px-4">
                    <div className="flex justify-between w-full mx-auto max-w-7xl">
                        <Link to={`/${lang}`} className="flex flex-col gap-1 justify-center items-center">
                            <div><img src={anchor} className="w-[64px] h-[64px]" /> </div>
                            <div className="text-xl font-black">BECSM</div>
                        </Link>
                        <div className="hidden sm:flex items-center gap-8">
                            <NavItem title="+216 25 241 240" desc={t("callUsNow")} icon={<PhoneIcon className="h-6 w-6 text-white" />} />
                            <NavItem title="contact@becsm.com" desc={t("dropUsAnEmail")} icon={<EnvelopeIcon className="h-6 w-6 text-white" />} />
                            <NavItem title="08:00 - 18:00 (6/7)" desc={t("officeOpeningHours")} icon={<ClockIcon className="h-6 w-6 text-white" />} />
                            <div className="flex gap-1 items-center">
                                <button onClick={() => switchLanguage("fr")} className={`rounded-full h-8 w-8 ${lang == "fr" ? "font-bold bg-gray-200" : "font-light"}`} >🇫🇷</button>|
                                <button onClick={() => switchLanguage("en")} className={`rounded-full h-8 w-8 ${lang == "en" ? "font-bold bg-gray-200" : "font-light"}`} >🇬🇧</button>
                            </div>
                        </div>
                        <div className="flex gap-2">
                            <div className="flex gap-1 items-center sm:hidden">
                                <button onClick={() => switchLanguage("fr")} className={`rounded-full h-8 w-8 ${lang == "fr" ? "font-bold bg-gray-200" : "font-light"}`} >🇫🇷</button>|
                                <button onClick={() => switchLanguage("en")} className={`rounded-full h-8 w-8 ${lang == "en" ? "font-bold bg-gray-200" : "font-light"}`} >🇬🇧</button>
                            </div>
                            <button className="sm:hidden" onClick={toggleMenu}>
                                <Bars3Icon className="h-8 w-8 text-primary" />
                            </button>
                        </div>
                    </div>
                </nav>
            </header>
            <nav className="hidden bg-primary h-[83px] sm:flex items-center sticky top-0 z-20 font-[Oswald,sans-serif]">
                <ul className="flex text-white justify-between max-w-2xl mx-auto w-full uppercase">
                    {renderNavItems()}
                </ul>
            </nav>
            <MobileNavbar navItems={LINKS} lang={lang} open={open} toggleMenu={toggleMenu} />
        </>
    );
}

export default Navbar;
